import { render, staticRenderFns } from "./myinfo.vue?vue&type=template&id=071f3209&scoped=true"
import script from "./myinfo.vue?vue&type=script&lang=js"
export * from "./myinfo.vue?vue&type=script&lang=js"
import style0 from "./myinfo.vue?vue&type=style&index=0&id=071f3209&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071f3209",
  null
  
)

export default component.exports